import { render, staticRenderFns } from "./DryCowConsultActions.vue?vue&type=template&id=1f0ac3b7&"
import script from "./DryCowConsultActions.vue?vue&type=script&lang=js&"
export * from "./DryCowConsultActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports